interface ITransparencyHeading {
  heading: string
  subHeading: string
  descriptions: string[]
}

export function TransparencyHeading({
  heading,
  subHeading,
  descriptions,
}: ITransparencyHeading) {
  return (
    <div className="m-auto text-center max-w-155">
      <span className="text-3xl font-bold text-acai">{subHeading}</span>
      <h3 className="mb-8 font-bold text-acai text-[35px] md:text-[50px]">
        {heading}
      </h3>
      <div className="text-2xl md:mb-4 md:text-3xl md:leading-snug">
        {descriptions.map((description, index) => (
          <p
            key={index}
            className="text-content-base text-[15px] md:text-[18px]"
          >
            {description}
          </p>
        ))}
      </div>
    </div>
  )
}
